module.exports = __webpack_public_path__ + "img/spring.1fe1b928.png";